import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SnSheet from "@shared/components/Grid/SnSheet";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnButton from "@shared/components/SnButton";
import { getInitForm, getInitFormData } from "@shared/utils/CommonUtils";
import { ExcelUploadProps } from "@menu/XTC/SN_SAL_SAO_REG_001_TEX/excel-upload-tex/types";
import { showDialog } from "@widgets/CommonDialog";
import { getCodeData } from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import SN_SAL_SAO_REG_001_TEX_POP_01 from "@menu/XTC/SN_SAL_SAO_REG_001_TEX/SN_SAL_SAO_REG_001_TEX_POP_01";

type S01WithModalProps = ExcelUploadProps & {
  modalRef?: React.RefObject<any>;
};

const ExcelUpload_S01_Validate = forwardRef<any, S01WithModalProps>(
  ({ modalRef, ...props }, ref) => {
    const { Menuprops, grouping, pkFields, compareFields, onNext } = props;

    const gridref1 = useRef<any>(null);

    const [columns1, setColums1] = useState<any[]>([]); // H 컬럼
    const [columns2, setColums2] = useState<any[]>([]); // L 컬럼
    const [sheet1Columns, setSheet1Columns] = useState<any[]>([]); // 엑셀 검증 컬럼
    const [dataSource1, setDataSource1] = useState<any>();
    const [codeDataList, setCodeDataList] = useState<Record<string, string>[]>(
      []
    );

    //#region grid 길이 관련
    let width1 = "99%";
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.ExcelUpload) {
        width1 = menu.ExcelUpload.grid1Width
          ? menu.ExcelUpload.grid1Width
          : width1;
      }
    }
    const [grid1Width, setGrid1Width] = useState<string | number>(width1);

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        const closeFlag = await handleValidateThenNext();
        return { excelUpload: closeFlag };
      },
    }));

    // any 그대로 사용
    useEffect(() => {
      (async () => {
        const rtn: any = await getInitFormData();
        setColums1(rtn.grid.grid1); // H 컬럼
        setColums2(rtn.grid.grid2); // L 컬럼
        setSheet1Columns(rtn.grid.sheet1); // 엑셀 검증 컬럼

        // 최초 화면 오픈 시점에 엑셀 업로드 그리드 초기화

        gridref1.current?.resetGridData?.();
      })();
    }, []);

    // 코드치환 필요 시 주입
    useEffect(() => {
      (gridref1.current as any)?.setCodeDataList?.(codeDataList);
    }, [codeDataList]);

    const Validation = async (updatevalue: boolean): Promise<boolean> => {
      //  Validation 실행하여 오류 체크
      // const data = await getCodeData(tableName, ""); //  data insert update체크할 데이터 조회
      // setCodeDataList(data); // 기존 데이터 목록 저장

      if (gridref1.current.api.getDisplayedRowCount() <= 1) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return true;
      }
      // BE에서 처리
      // const codeData = await getCodeData("POPUP_STYLE", "");

      // const rowNodes: any[] = [];
      // gridref1.current.api.forEachNode((node: any) => rowNodes.push(node));
      // let matchingStyle = "";
      // let dataStyle, dataCust, dataNmStyle;
      // let cd_var1 = "",
      //   cd_var2 = "",
      //   cd_var3 = "";
      // for (const node of rowNodes) {
      //   if (!node.data.no_style) continue;
      //   dataStyle = node.data.no_style;
      //   dataCust = node.data.cd_cust;
      //   dataNmStyle = node.data.nm_style;
      //   cd_var1 += node.data.cd_var1 + ",";
      //   cd_var2 += node.data.cd_var2 + ",";
      //   cd_var3 += node.data.cd_var3 + ",";
      //   matchingStyle = codeData.find(
      //     (item: any) =>
      //       item.code === node.data.no_style || item.name === node.data.no_style
      //   );
      // }
      // if (undefined === matchingStyle) {
      //   const selectedData = {
      //     no_style: dataStyle,
      //     nm_style: dataNmStyle,
      //     cd_cust: dataCust,
      //     cd_var1: cd_var1,
      //     cd_var2: cd_var2,
      //     cd_var3: cd_var3,
      //   };
      //   const component = (
      //     <SN_SAL_SAO_REG_001_TEX_POP_01 selectedData={selectedData} />
      //   );
      //   const result = await showPopupModal({
      //     title: "규격등록",
      //     children: component,
      //     validation: true,
      //     okayBtn: false,
      //     closeBtn: false,
      //     checkData: false,
      //   });

      //   if (!result || result === "close") return false;
      // }
      //return false;
      const isValid = await gridref1.current.validateData(updatevalue);
      if (!isValid) {
        showDialog("error", "오류내역을 확인해주세요.");
        return false;
      }

      // 2단에서 한 줄로 묶일 행(no_po, no_style, cd_dummy01, cd_var1~3 동일)끼리 단가가 다르면 막는다
      const umConflicts = findUmConflicts(collectAllRows());
      if (umConflicts.length > 0) {
        await showDialog(
          "error",
          "같은 PO/Style/Location/Fit/Color/Size 인데 단가가 다른 행이 있습니다.\n" +
            umConflicts.slice(0, 5).join("\n") +
            (umConflicts.length > 5 ? `\n외 ${umConflicts.length - 5}건` : "")
        );
        return false;
      }
      return true;
    };

    const onGrid1BtnsClick = async (id: string) => {
      if (id == "aButton_Init") {
        gridref1.current.resetGridData();
      }

      if (id == "aButton_Validation") {
        const isValid = await Validation(false);
        if (isValid) {
          await showDialog("success", "오류가 없습니다.");
        }
      }
    };

    // 2) 검증 후 다음: 통과 시 모든 업로드 행을 2단으로 전달
    const handleValidateThenNext = async () => {
      try {
        const isValid = await Validation(false);
        if (!isValid) {
          return false;
        }

        if (gridref1.current.getChange().modifiedRowcount === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return false;
        }

        // if (
        //   gridref1.current.getChange().update &&
        //   gridref1.current.getChange().update.length > 0
        // ) {
        //   const confirm = await showDialog(
        //     "confirm",
        //     "이미 등록된 내역이 있습니다. 덮어쓰시겠습니까?"
        //   );
        //   if (!confirm) {
        //     return;
        //   }
        // }
        await Validation(true);
        const validRows = collectAllRows();
        if (validRows.length === 0) {
          // await showDialog("alter", "검증 통과 데이터가 없습니다.");
            return false;
        }

        await onNext({
          validRows,
          headerColumns: columns1,
          detailColumns: columns2,
          grouping,
        });

        return true;
      } catch (error: any) {}
    };

    // 묶음 키별 단가 비교 ($19.57, "1,000" 같은 값도 숫자로 비교)
    const findUmConflicts = (rows: any[]) => {
      const mergeFields = Array.from(
        new Set([
          ...(grouping ?? []),
          "no_po",
          "no_style",
          "cd_dummy01",
          "cd_var1",
          "cd_var2",
          "cd_var3",
        ])
      );
      const toNum = (v: any) =>
        Number(String(v ?? "").replace(/[^0-9.-]/g, "")) || 0;
      const umByKey = new Map<string, number>();
      const conflicts: string[] = [];
      for (const r of rows) {
        const k = mergeFields.map((f) => r?.[f] ?? "").join("||");
        const um = toNum(r.um);
        if (!umByKey.has(k)) {
          umByKey.set(k, um);
        } else if (umByKey.get(k) !== um) {
          const label = `${r.no_po ?? ""} / ${r.no_style ?? ""} / ${r.cd_dummy01 ?? ""} / ${r.cd_var1 ?? ""} / ${r.cd_var2 ?? ""} / ${r.cd_var3 ?? ""}`;
          if (!conflicts.includes(label)) conflicts.push(label);
        }
      }
      return conflicts;
    };

    // 상수 (빈값 체크용)
    const SKIP_FIELDS = new Set(["__op", "__state", "No.", "no", "rowIndex"]);

    // 1) 필드 목록: sheet1Columns 우선, 없으면 첫 행 키로 폴백 (1회 계산)
    const hasInput = (row: any) => {
      const fields = (sheet1Columns ?? [])
        .map((c: any) => c?.field)
        .filter(Boolean);

      const check = (v: any) =>
        v === 0 || v === false || (v != null && String(v).trim() !== "");

      if (fields.length > 0) {
        return fields.some((f) => check(row[f]));
      }

      // fallback: schema 없을 때만 KeyField 제외
      return Object.entries(row)
        .filter(([k]) => k !== "KeyField")
        .some(([, v]) => check(v));
    };

    const collectAllRows = () => {
      const api = gridref1.current?.api;
      if (!api) return [];
      const out: any[] = [];
      api.forEachNode((node: any) => {
        const r = node?.data;
        if (r && hasInput(r)) out.push({ ...r });
      });
      return out;
    };

    // grid1의 width resize
    const onResizeStopH = (width: number) => {
      setGrid1Width(width);
    };

    return (
      <div className="h-full flex flex-col">
        <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
          <SnResizableLNR
            width={"99%"}
            minWidth={130}
            onResizeStop={() => {}}
            enable={{ right: true }}
            menuName={Menuprops.cd_menu ?? ""}
            defaultSize={{ grid2Width: "99%" }}
          >
            <SnSheet
              menuInfo={Menuprops}
              ref={gridref1}
              enableAddRow={true}
              columnConfig={sheet1Columns}
              rowData={dataSource1}
              isEditable={true}
              enableFillHandle={true}
              codeDataList={codeDataList}
              compareFields={compareFields ?? pkFields ?? []}
              title={Menuprops.nm_menu}
              header={
                <div>
                  <SnButton
                    text={"초기화"}
                    onClick={() => {
                      onGrid1BtnsClick("aButton_Init");
                    }}
                  />
                  <SnButton
                    text={"오류체크"}
                    onClick={() => {
                      onGrid1BtnsClick("aButton_Validation");
                    }}
                  />
                </div>
              }
            />
          </SnResizableLNR>
        </div>
      </div>
    );
  }
);
export default ExcelUpload_S01_Validate;
